<template>
<div id="index-page" class="">
  <b-navbar type="light" variant="light-success">
    <b-navbar-brand href="#">
      <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
      {{ logoName }}
    </b-navbar-brand>
    <b-navbar-nav class="ml-auto" v-b-scrollspy>
      <b-nav-item href="#contact">ติดต่อเรา</b-nav-item>
      <b-button variant="outline-licm" class="my-2 my-sm-0 px-4" v-if="!dataReady" @click="loginUser">เข้าสู่ระบบ</b-button>
      <template v-if="dataReady">
        <b-nav-item :to="{ path: '/pod/OrderList' }" replace>รายการข้อมูลพรีออร์เดอร์</b-nav-item>
        <b-nav-item :to="{ path: '/User/Tracking' }" replace>รายการรหัสพัสดุ</b-nav-item>
        <b-nav-item> | ยินดีต้อนรับ {{ userData.firstName + " " + userData.lastName }}</b-nav-item>
        <b-button variant="outline-licm" class="my-2 my-sm-0 px-4" @click="logoutUser">ออกจากระบบ</b-button>
      </template>
    </b-navbar-nav>
  </b-navbar>

  <b-container fluid>
    <b-row class="bg-white d-none d-lg-block">
      <img src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/AdobeStock_480886056_2.png?alt=media&token=6a2c9e17-a67b-4196-834b-2884a15d437a" alt="img" width="1200px">
      <img src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/newLicm%2FGroupTEXT.png?alt=media&token=1b586769-2e44-4144-bb73-28c4714e5f6f" alt="Logo" width="40%" class="cover-img">
    </b-row>
    <b-row class="d-lg-none">
      <b-card
        overlay
        :img-src="require('@/assets/hero.png')"
        img-alt="LICM WELCOME"
        class="w-100 card-img-welcome"
      >
      </b-card>
    </b-row>
        <br>
        <br>


    <b-row>
      <b-col sm="10" class="mx-auto">
        <b-card class="text-center pic-shadow bor-licm">
          <div class="">
            <h1>เรทราคาการขนส่งจากจีน</h1>
          </div>
          <b-row>
            <b-col md="6">
              <!-- <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/new_price_20032023%2FnewPrice%20(4).jpg?alt=media&token=d375bbfd-5930-490a-8b19-6490b90fdcae"></b-img-lazy> -->
              <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/newprice_0424%2Flicm_track_0424.jpg?alt=media&token=f2f2c4be-1329-4c73-a87a-365489fc1ef7"></b-img-lazy>
            </b-col>
            <b-col md="6">
              <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/newLicm%2Fpricenb.jpg?alt=media&token=805078f3-d13c-4291-b993-035d02fb8751"></b-img-lazy>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="text-center pic-shadow bor-licm my-3">
          <div class="">
            <h1>เรทราคาสมาชิก VIP</h1>
          </div>
          <b-row>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2 zoom" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/new_price_20032023%2FnewPrice%20(1).jpg?alt=media&token=bf2a5617-cac2-418d-872d-41f021a0f711"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2 zoom" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/new_price_20032023%2FnewPrice%20(2).jpg?alt=media&token=2f68a5ed-f5e9-45ee-bafd-2e7f8ad1f7b9"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2 zoom" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/new_price_20032023%2FnewPrice%20(3).jpg?alt=media&token=e76b6001-e092-4eea-b170-64286ac5bbb2"></b-img-lazy>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="text-center pic-shadow" style="border: 0px; background-color: transparent;">
          <b-row>
            <b-col md="4">
              <!-- <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/price1.jpg?alt=media&token=5ac875b1-6b4c-4c28-a5fa-0a9a76b5e14c"></b-img-lazy> -->
              <b-img-lazy center style="max-width: 900px;" class="w-100 my-5 bor-licm" :src="processLicmImage"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <!-- <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/price2.jpg?alt=media&token=59eb8c9b-240a-4df7-9559-19e1b6d7e368"></b-img-lazy> -->
            <b-img-lazy center style="max-width: 940px;" class="w-100 my-5 bor-licm" :src="timingLicmImage"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <!-- <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/price2.jpg?alt=media&token=59eb8c9b-240a-4df7-9559-19e1b6d7e368"></b-img-lazy> -->
            <b-img-lazy center style="max-width: 940px;" class="w-100 my-5 bor-licm" :src="calNewLICMImage"></b-img-lazy>
            </b-col>
          </b-row>
        </b-card>


        <b-card class="text-center pic-shadow bor-licm">
          <div class="">
            <h1>บริการของเรา</h1>
          </div>
          <b-row>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/newLicm%2FtranChai.jpg?alt=media&token=c1fedb7c-aa81-4968-a8e7-6bf4dbce2264"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/newLicm%2FPREordLicm.jpg?alt=media&token=d6e64ef7-9163-442f-ad9a-0f9dc9cfe841"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/newLicm%2FMOTRNew.jpg?alt=media&token=54810311-9af5-45ce-a090-dce39286cf85"></b-img-lazy>
            </b-col>
            <b-col md="4">
              
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/001.jpeg?alt=media&token=6aadc097-0b5e-4b3e-84de-a171118fa978"></b-img-lazy>
            </b-col>
            <b-col md="4">

            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row id="contact">
      <b-card
        overlay
        :img-src="require('@/assets/footer.jpg')"
        img-alt="LICM WELCOME"
        class="w-100 border-0 mt-5"
      >
      </b-card>
    </b-row>

  </b-container>
</div>
</template>

<script>

export default {
  name: 'Index',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
    // document.body.className = 'login';
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    // this.$session.destroy()
    // localStorage.removeItem('memberData')
    this.getDataUser()
  },
  data () {
    return {
      msg: 'Welcome LICM',
      dataReady: false,
      processLicmImage: require('@/assets/ProcessLicm.jpg'),
      timingLicmImage: require('@/assets/timingLicm.jpg'),
      calNewLICMImage: require('@/assets/calLicm.jpg'),
      userData: {
        userName: '',
        userCode: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: '',
      },
    }
  },
  methods: {
    getDataUser () {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
        this.dataReady = true
      } else {
        this.dataReady = false;
      }
    },
    logoutUser () {
      this.$session.destroy()
      this.$router.go(this.$router.currentRoute)
    },
    loginUser () {
      this.$router.push('/Login')
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#index-page {
  font-family: 'Kanit', sans-serif !important;
}

.form-login{
  margin-top: 60px;
}
label{
  font-weight: 600;
}

.btn-outline-licm {
    color: #1a5231;
    background-color: #fff;
    border-color: #1a5231;
    font-weight: 400;
}

.btn-outline-licm:hover {
    color: #fff;
    background-color: #1a5231;
    border-color: #1a5231;
}

.card-img-welcome img{
  max-width: 1000px;
}

img.cover-img {
  position: absolute;
  bottom: 40%;
  right: 10%;
}

.pic-shadow img {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.pic-shadow div.row div:hover {
  z-index: 100;
}

img.zoom {
  transition: transform .2s;
}

img.zoom:hover {
  -ms-transform: scale(1.5);
  -webkit-transform: scale(1.5);
  transform: scale(1.5);
}

.bor-licm {
  border: 5px #245c3b solid;
  /* border: 5px #FF7F63 solid; */
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue